function DomReady(fn) {
    if (typeof fn !== 'function') {
        return;
    }
    if (document.readyState === 'interactive' || document.readyState === 'complete') {
        return fn();
    }
    document.addEventListener('DOMContentLoaded', fn, false);
}

function jsLoaded() {
    const htmlTag = document.querySelector('html')
    htmlTag.classList.remove('no-js');
    htmlTag.classList.add('js');
}

function addMenuToggle() {
    const menuHasChildrean = document.querySelectorAll('#main-nav .menu-item-has-children > a');
    for (var i = 0; i < menuHasChildrean.length; i++) {
        let id = menuHasChildrean[i].parentNode.getAttribute('id') + '-toggle';
        menuHasChildrean[i].insertAdjacentHTML('afterend', '<input type="checkbox" id="' + id + '">' +
            '<label for="' + id + '" class="menu-toggle">' +
            '<em aria-hidden="true"></em>' +
            '<span class="screen-reader-text">more</span>' +
            '</label>');
    }
}

function currentMenu() {
    const checkboxes = document.querySelectorAll('.current-menu-parent > input[type="checkbox"], .current-menu-ancestor > input[type="checkbox"]');
    for (checkbox of checkboxes) {
        checkbox.checked = true;
    }
}


DomReady(() => {
    jsLoaded();
    addMenuToggle();
    currentMenu();
});

window.addEventListener("resize", function () {

});